import { API_DATA_FORMAT } from 'core-lib/constants/network';

export const getApiData = (data = null) => {
  return {
    ...API_DATA_FORMAT,
    data,
  };
};
